'use strict';

var _regeneratorRuntime = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var Datastore = require('datastore-fs');

var log = require('debug')('repo-migrations:repo:init');

var Key = require('interface-datastore').Key;

var versionKey = new Key('/version');
var configKey = new Key('/config');

exports.isRepoInitialized = /*#__PURE__*/function () {
  var _isRepoInitialized = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(path) {
    var root, versionCheck, configCheck;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            root = new Datastore(path, {
              extension: '',
              createIfMissing: false
            });
            _context.next = 4;
            return root.has(versionKey);

          case 4:
            versionCheck = _context.sent;
            _context.next = 7;
            return root.has(configKey);

          case 7:
            configCheck = _context.sent;

            if (!(!versionCheck || !configCheck)) {
              _context.next = 12;
              break;
            }

            log("Version entry present: ".concat(versionCheck));
            log("Config entry present: ".concat(configCheck));
            return _context.abrupt("return", false);

          case 12:
            return _context.abrupt("return", true);

          case 15:
            _context.prev = 15;
            _context.t0 = _context["catch"](0);
            log('While checking if repo is initialized error was thrown: ' + _context.t0.message);
            return _context.abrupt("return", false);

          case 19:
            _context.prev = 19;

            if (!(root !== undefined)) {
              _context.next = 23;
              break;
            }

            _context.next = 23;
            return root.close();

          case 23:
            return _context.finish(19);

          case 24:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 15, 19, 24]]);
  }));

  function isRepoInitialized(_x) {
    return _isRepoInitialized.apply(this, arguments);
  }

  return isRepoInitialized;
}();